import { StatusBar } from '@capacitor/status-bar';

export async function initStatusBar() {
  try {
    await StatusBar.setBackgroundColor({ color: '#047857' }); // Tailwind emerald-700
    await StatusBar.setStyle({ style: 'LIGHT' }); // white icons on dark green
  } catch {}
}

